import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=20a1cbc4&scoped=true&lang=pug&"
import script from "./Formulario.vue?vue&type=script&lang=js&"
export * from "./Formulario.vue?vue&type=script&lang=js&"
import style0 from "./Formulario.styl?vue&type=style&index=0&id=20a1cbc4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a1cbc4",
  null
  
)

export default component.exports